import { apiInstances } from '../../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function toReceiveFromWarecloud({ id_order, ...payload }) {
  return await post(`/clouders/orders/${id_order}/pickupWarecloud`, payload);
}
